import React from 'react';
import { Layout } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { connect, getLocale, useIntl } from 'umi';
import KeyMetricCard from './KeyMetricCard';
import IntentDistributionTrend from './IntentDistributionTrend';
import DetailsBox from './DetailsBox';
import './index.scss';
import CardLoading from '@op/components/CardLoading';
import { DBO_TM } from '@op/utils/format';
import { defaultFilterValue } from '@op/components/FilterCommon/constants';
import ContentBody from '@op/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import voiceReportingTextAnalysis from '@op/operationLog/pages/voiceReportingTextAnalysis';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';

const { Content } = Layout;
export interface IIntentOptions {
  key: string;
  'en-US': string;
  'zh-CN': string;
}
function VoiceReport({ gameInfo }: any) {
  const { formatMessage } = useIntl();

  useInitBuriedPointInfo({
    buriedPoint: voiceReportingTextAnalysis,
  });

  const { loading, filter, changeFilter, filterOptions, filterCommonParams } = useFilterDataHook({
    gameInfo,
    pageName: 'Voice_Reporting_Text_Analysis',
  });
  const [intentOptions, setIntentOptions] = React.useState<IIntentOptions[]>(
    [],
  );

  return (
    <Content className="dbo-page dbo-voice-report">
      <ContentBody
        pageName={PAGE_NAME.VOICE_REPORTING_TEXT_ANALYSIS}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: 'Voice Reporting Text Analysis' })}
          />
        }
      >
        <FilterFixed
          filter={filterOptions}
          operateShowOptions={null}
          isTile
          beforeCacheDealwithData={() => false}
          finallyDealwithDefaultValue={() => {
            return {
              ...defaultFilterValue(),
              ...DBO_TM.utcFilterRangeDay(6, 0),
            };
          }}
          backCondOriginData={(value: any) => {
            const { vrta_intent } = value;
            if (vrta_intent) {
              const intentOption = Object.entries(vrta_intent).map(
                ([key, value]) => ({
                  key,
                  'en-US': value as string,
                  'zh-CN': key,
                }),
              );
              setIntentOptions(intentOption);
            }
          }}
          defaultConfig={{
            date: { showTimeTips: false },
          }}
          defaultValue={{
            ...DBO_TM.utcFilterRangeDay(6, 0),
          }}
          confirm={(value) => {
            changeFilter({ ...value, ...gameInfo });
          }}
          {...filterCommonParams}
        ></FilterFixed>

        <CardLoading loading={loading}>
          <KeyMetricCard gameInfo={gameInfo} filter={filter}></KeyMetricCard>
          <IntentDistributionTrend
            gameInfo={gameInfo}
            filter={filter}
            intentOptions={intentOptions}
          ></IntentDistributionTrend>
          <DetailsBox
            gameInfo={gameInfo}
            filter={filter}
            intentOptions={intentOptions}
          ></DetailsBox>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export const transIntent = (
  intentOptions: IIntentOptions[],
  intent: string,
) => {
  const locale = getLocale();
  const target = intentOptions.find((item) => item.key === intent);
  if (target) {
    return target?.[locale] || intent;
  }
  return intent;
};

export default connect((state: any) => {
  const { opinionCommon, opinionFilter } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(VoiceReport);
